module.exports = __webpack_public_path__ + "static/media/percent.3fd18e98.svg";